export const DEFAULT_CONFIG = {
  brand: "BALIBIGVILLAS",
  whatsapp_number: "6281138216948",
  whatsapp_default_message:
    "Hi BALIBIGVILLAS, I would like to inquire about villa availability.",
};

export const waLink = (number, message) =>
  `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -64, duration: 1.5 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const FALLBACK_VILLAS = [
  {
    slug: "villa-serenity-sanctuary",
    title: "New 8 Bedr/10 Bathr Villa/Best Location/Near beach",
    location: "Petitenget, Seminyak",
    guests: 27,
    bedrooms: 8,
    bathrooms: 10,
    rating: 4.95,
    reviews_count: 21,
    airbnb_url: "https://www.airbnb.co.uk/rooms/1407741467853038297",
    airbnb_active: true,
    whatsapp_message:
      "Hi BALIBIGVILLAS, I'm interested in booking the 8-bedroom villa in Petitenget, Seminyak: https://www.airbnb.co.uk/rooms/1407741467853038297",
    description:
      "A beautifully appointed 8-bedroom private estate in Petitenget, Seminyak — moments from Potato Head and Petitenget Beach, with a large private pool, full daily staff, and a dedicated villa manager.",
    images: ["/images/villas/villa1-1.jpg", "/images/villas/villa1-2.jpg", "/images/villas/villa1-3.jpg"],
  },
  {
    slug: "the-bamboo-haven-estate",
    title: "Huge&Trendy/ 7 BEDR Pool Villa/ Near Beach & Clubs",
    location: "Canggu",
    guests: 16,
    bedrooms: 7,
    bathrooms: 6.5,
    rating: 4.91,
    reviews_count: 74,
    airbnb_url: "https://www.airbnb.co.uk/rooms/902472003975166532",
    airbnb_active: true,
    whatsapp_message:
      "Hi BALIBIGVILLAS, I'm interested in booking the 7-bedroom pool villa in Canggu (near beach & clubs): https://www.airbnb.co.uk/rooms/902472003975166532",
    description:
      "A huge, trendy 7-bedroom pool villa in Canggu, minutes from the beach and the area's iconic clubs — smart TVs in every bedroom, high-speed Wi-Fi, and daily villa staff.",
    images: ["/images/villas/villa2-1.jpg", "/images/villas/villa2-2.jpg", "/images/villas/villa2-3.jpg"],
  },
  {
    slug: "maison-minimaliste-canggu",
    title: "Huge 11BR Villa, Sleeps 41, Prime Area, Near Beach",
    location: "Berawa, Canggu",
    guests: 41,
    bedrooms: 11,
    bathrooms: 12.5,
    rating: 4.97,
    reviews_count: 67,
    airbnb_url: "https://www.airbnb.co.uk/rooms/41627730",
    airbnb_active: true,
    whatsapp_message:
      "Hi BALIBIGVILLAS, I'm interested in booking the 11-bedroom villa in Berawa, Canggu (sleeps 41): https://www.airbnb.co.uk/rooms/41627730",
    description:
      "An expansive 11-bedroom private pool villa in Berawa, Canggu sleeping up to 41 guests — built for retreats, celebrations, and intimate weddings, just 10 minutes from the beach.",
    images: ["/images/villas/villa3-1.jpg", "/images/villas/villa3-2.jpg", "/images/villas/villa3-3.jpg"],
  },
  {
    slug: "villa-lumina-seminyak",
    title: "Best Location!/ Big 9 Bedr / 9 Bathr/ Near Beach",
    location: "Oberoi, Seminyak",
    guests: 24,
    bedrooms: 9,
    bathrooms: 9,
    rating: 4.84,
    reviews_count: 116,
    airbnb_url: "https://www.airbnb.co.uk/rooms/5762464",
    airbnb_active: true,
    whatsapp_message:
      "Hi BALIBIGVILLAS, I'm interested in booking the 9-bedroom estate in Oberoi, Seminyak: https://www.airbnb.co.uk/rooms/5762464",
    description:
      "A 9-bedroom private estate in prestigious Oberoi, Seminyak, moments from Petitenget Beach, Potato Head, and La Favela, with full professional staff and a large private pool.",
    images: ["/images/villas/villa4-1.jpg", "/images/villas/villa4-2.jpg", "/images/villas/villa4-3.jpg"],
  },
  {
    slug: "aura-villa-spa-seminyak",
    title: "Location! 7 Bedr/7.5 Bathr Pool Villa/near beach",
    location: "Seminyak",
    guests: 22,
    bedrooms: 7,
    bathrooms: 7.5,
    rating: 4.88,
    reviews_count: 50,
    airbnb_url: "https://www.airbnb.co.uk/rooms/29150901",
    airbnb_active: true,
    whatsapp_message:
      "Hi BALIBIGVILLAS, I'm interested in booking the 7-bedroom pool villa in Seminyak: https://www.airbnb.co.uk/rooms/29150901",
    description:
      "A 7-bedroom pool villa in the heart of Seminyak, a short walk from Seminyak Beach, with ensuite bedrooms, a private pool, and a dedicated villa manager.",
    images: ["/images/villas/villa5-1.jpg", "/images/villas/villa5-2.jpg", "/images/villas/villa5-3.jpg"],
  },
  {
    slug: "the-grand-ricefield-residence",
    title: "Huge 9 Bedr/10 Bath Villa/Best Location/near beach",
    location: "Berawa, Canggu",
    guests: 31,
    bedrooms: 9,
    bathrooms: 10,
    rating: 4.97,
    reviews_count: 29,
    airbnb_url: "https://www.airbnb.co.uk/rooms/1447594567348954989",
    airbnb_active: true,
    whatsapp_message:
      "Hi BALIBIGVILLAS, I'm interested in booking the 9-bedroom villa in Berawa, Canggu (sleeps 31): https://www.airbnb.co.uk/rooms/1447594567348954989",
    description:
      "A 9-bedroom modern escape in Berawa, Canggu sleeping up to 31 — large private pool, traditional Balinese gazebo, and full daily staff, 10 minutes from Finns Beach Club.",
    images: ["/images/villas/villa6-1.jpg", "/images/villas/villa6-2.jpg", "/images/villas/villa6-3.jpg"],
  },
];

export const FALLBACK_REVIEWS = [
  {
    quote:
      "The villa is beautiful, clean, and in a great location. The rooms were comfortable and well-equipped — the staff were friendly, welcoming, and always happy to help.",
    author: "Michael",
    country: "Verified Airbnb Guest",
    villa: "8BR Villa, Seminyak",
    rating: 5,
  },
  {
    quote:
      "The villa was perfect for our group of 21 — designed to offer privacy if you wanted it, but also perfect for hanging out together. The rooms were lovely and the staff were amazing.",
    author: "Melanie",
    country: "Verified Airbnb Guest",
    villa: "11BR Villa, Berawa Canggu",
    rating: 5,
  },
  {
    quote:
      "We stayed as a group of 14 and had an amazing time. The villa is genuinely beautiful — spacious rooms, relaxing common areas, and a lovely pool — and the location is spot on.",
    author: "Katherine",
    country: "Verified Airbnb Guest",
    villa: "9BR Villa, Seminyak",
    rating: 5,
  },
];
